module.exports = __webpack_public_path__ + "static/img/4.55d5a1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/hospital1/4.png
// module id = 6RqR
// module chunks = 1